<template lang="pug">
  #PersonnelScheduleModel.CustomerModel.CustomerModel-reservationModel(
    :class="{ 'CustomerModel-active': showModel }",
    :style="[{Zindex: Zindex}, modelCSS]"
  )
    .row.align-items-start.mb-2
      .col-10
        h2.mb-0 {{ title }}
      .col-2
        img.rounded-circle.closeIcon(
          v-lazy="iconUrl.IconClose",
          fluid,
          alt="Close Icon",
          @click="closeModel()"
        )
    h5.font-weight-bold.text-center.letter-spacing-6 預覽店舖預約狀態
    hr.border.border-primary.w-100
    .content
      .bg-light.py-3.px-5.text-center.position-relative
        input.form-control(
          type="date",
          v-model="selectedDate",
          class="text-center",
          @change="changeSelectedDateHandler()",
          v-if="canChangeDate"
        )
        p.text-center.mb-0(
          v-if="!canChangeDate"
        ) {{ selectedDate }}
      div(
        v-if="reservationCalendarInfo"
      )
        .p-3
          .row
            .col-4(
              v-for="(personnel,index) in reservationCalendarInfo.personnel"
              :key="index"
            )
              b-badge.rounded-0.p-2.w-100(
                variant="light",
                :class="index > 2 ? 'mt-3' : ''"
              ) {{ personnel }}
        div.border-width-lg(
          v-for="(schedule,index) in reservationCalendarInfo.reservation",
          :key="index"
        )
          .row.no-gutters.py-2.text-center(
            :class="schedule.personnel_type_name === null ? 'bg-light' : 'bg-primary'"
          )
            .col-3.d-flex.align-items-center.justify-content-center
              small {{ schedule.personnel_name }}
            .col-3.d-flex.align-items-center.justify-content-center
              small {{ schedule.personnel_type_name }}
            .col-3.d-flex.align-items-center.justify-content-center
              small {{ schedule.start_time }}~{{ schedule.end_time }}
            .col-3.d-flex.align-items-center.justify-content-center
              small {{ schedule.site }}
      h5.text-center.mt-3(
        v-else
      ) 當日無預約資料
</template>

<script>
import { mapState } from 'vuex';
// Icon
import IconCloseUrl from '@/assets/images/icon/icon_close.png';
import IconClendartUrl from '@/assets/images/icon/icon_calendar.png';

const moment = require('moment');

export default {
  name: 'PersonnelScheduleModel',
  props: {
    title: {
      type: String,
      default: ''
    },
    Zindex: {
      type: String,
      default: '15px'
    },
    modelCSS: {
      type: Object,
      default: null
    },
    canChangeDate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showModel: false,
      iconUrl: {
        IconClose: IconCloseUrl,
        IconClendart: IconClendartUrl
      },
      selectedDate: null,
      store_id: null
    };
  },
  mounted() {
    this.$EventBus.$on('openPersonnelScheduleModel', (info) => {
      if (!info.store_id) return;
      this.openModel(info);
    });
  },
  methods: {
    initHandler({ date, store_id }) {
      const vm = this;
      if (date) {
        vm.selectedDate = date;
      } else {
        vm.selectedDate = moment().format('YYYY-MM-DD');
      }
      vm.store_id = store_id;
      vm.changeSelectedDateHandler();
    },
    openModel(info) {
      this.initHandler(info);
      this.showModel = true;
    },
    closeModel() {
      this.$emit('scrollToTarget');
      this.selectedDate = moment().format('YYYY-MM-DD');
      this.showModel = false;
    },
    changeSelectedDateHandler() {
      const vm = this;
      if (!vm.store_id) return;
      vm.$swal.fire({
        title: '請稍候，\n載入中',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      vm.$store.dispatch('common_reservation/getReservationCalendarInfoHandler', {
        reserve_date: vm.selectedDate,
        store_id: vm.store_id
      })
        .then(() => {
          vm.$swal.close();
        });
    }
  },
  beforeDestroy() {
    this.$EventBus.$off('openPersonnelScheduleModel');
  },
  computed: {
    ...mapState({
      reservationCalendarInfo: (state) => state.common_reservation.reservationCalendarInfo
    })
  }
};
</script>

<style>

</style>
